import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormConfig } from '@symplicity/syng';
import * as _ from 'lodash';
import { EventsService } from '../../../services';

@Component({
    selector: 'cf-more-filters',
    templateUrl: './more-filters.component.html'
})
export class MoreFilters implements OnInit, OnDestroy {
    @Input()
    public filtersFormConfig: FormConfig;

    @Input()
    public formValue: any;

    @Output()
    public readonly onClear = new EventEmitter<void>();

    @Output()
    public readonly onCancel = new EventEmitter<void>();

    @Output()
    public readonly onApply = new EventEmitter<any>();

    public formGroup: UntypedFormGroup;
    public moreFiltersControls: any;
    private initialValue: any;
    private isCanceled = false;
    private isApplied = false;

    constructor(private eventsService: EventsService) {}

    public ngOnInit(): void {
        this.formGroup = this.eventsService.createFormGroup(
            this.filtersFormConfig.controls.filter(control => !control.isSimpleFilter),
            this.formValue
        );
        this.initialValue = { ...this.formValue };
        this.moreFiltersControls = this.filtersFormConfig.controls.filter(control => !control.isSimpleFilter);
    }

    public ngOnDestroy(): void {
        if (!this.isCanceled && !this.isApplied) {
            this.apply();
        }
    }

    public clear(): void {
        const formValue = {};

        this.filtersFormConfig.controls.forEach(control =>
            formValue[control.name] = control.multiple ? new Array() : null
        );

        this.isCanceled = true;
        this.formGroup.reset(formValue);
        this.onClear.emit();
    }

    public cancel(): void {
        this.isCanceled = true;
        this.onCancel.emit();
    }

    public apply(): void {
        if (this.hasChanged(this.initialValue, this.formGroup.value)) {
            this.isApplied = true;
            this.onApply.emit(this.formGroup.value);
        }
    }

    private hasChanged(initial: any, changed: any): boolean {
        if (Object.keys(initial).length != Object.keys(changed).length) {
            return true;
        } else {
            Object.keys(initial).forEach(function(key) {
                if (_.isNull(initial[key]) && changed.hasOwnProperty(key) && _.isArray(changed[key])) {
                    initial[key] = [];
                }
            })
        }

        return JSON.stringify(initial) !== JSON.stringify(changed);
    }
}
